/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var WebChatFontSize;
(function (WebChatFontSize) {
    WebChatFontSize["SMALL"] = "SMALL";
    WebChatFontSize["MEDIUM"] = "MEDIUM";
    WebChatFontSize["LARGE"] = "LARGE";
})(WebChatFontSize || (WebChatFontSize = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var WebChatAvatarType;
(function (WebChatAvatarType) {
    WebChatAvatarType["AGENT"] = "AGENT";
    WebChatAvatarType["GENERIC"] = "GENERIC";
    WebChatAvatarType["CUSTOM"] = "CUSTOM";
})(WebChatAvatarType || (WebChatAvatarType = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var WebChatIconType;
(function (WebChatIconType) {
    WebChatIconType["GENERIC"] = "GENERIC";
    WebChatIconType["CUSTOM"] = "CUSTOM";
})(WebChatIconType || (WebChatIconType = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var WebChatPosition;
(function (WebChatPosition) {
    WebChatPosition["LEFT"] = "LEFT";
    WebChatPosition["RIGHT"] = "RIGHT";
})(WebChatPosition || (WebChatPosition = {}));
//# sourceMappingURL=types.js.map